// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { userListHeaderStyles } from "@guestsupply/Overrides/Widgets/UserList/UserListHeader";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

userListHeaderStyles.wrapper = {
    css: css`
        margin-bottom: 25px;
    `,
};

userListHeaderStyles.titleGridItem = {
    width: [10, 10, 8, 9, 9],
};

userListHeaderStyles.buttonsGridItem = {
    css: css`
        justify-content: flex-end;
    `,
    width: [2, 2, 4, 3, 3],
};

userListHeaderStyles.createUserButton = {
    css: css`
        justify-content: flex-end;
    `,
};

userListHeaderStyles.searchContainer = {
    gap: 10,
};

userListHeaderStyles.searchGridItem = {
    width: [12, 12, 8, 6, 6],
};

userListHeaderStyles.searchForm = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 15px;
        width: 100%;
    `,
};

userListHeaderStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            flex: 1 0 250px;
            ${xScreen("lte", "sm")} {
                flex: 1 0 auto;
            }

            && input {
                padding: 0 35px 0 9px;

                &:focus {
                    padding: 0 35px 0 9px;
                }
            }
        `,
    },
    iconProps: { src: "Search" },
};

userListHeaderStyles.actionsWrapper = {
    css: css`
        display: flex;
        gap: 15px;
    `,
};

userListHeaderStyles.clearButton = {
    css: css`
        flex: 0 0 auto;
    `,
    variant: "secondary",
};

userListHeaderStyles.searchSubmitButton = {
    css: css`
        flex: 0 0 auto;
    `,
    variant: "primary",
};

userListHeaderStyles.userCountGridItem = {
    width: [12, 12, 4, 6, 6],
    css: css`
        justify-content: flex-end;
    `,
};

userListHeaderStyles.userCountText = {
    ...myAccountFilterSectionStyles.orderCountText,
};
